import util from "@/libs/util";
export default {
  install: function install(Vue, options) {
    Vue.prototype.$open = util.open;
  }
};